/** Wave 1 M09 — SCR-MER-063–072, 088, 089 floor-mode bindings (07-02) */

export const KITCHEN_DISPLAY_SCREEN_IDS = [
  'SCR-MER-063',
  'SCR-MER-064',
  'SCR-MER-065',
  'SCR-MER-066',
  'SCR-MER-067',
  'SCR-MER-068',
  'SCR-MER-069',
  'SCR-MER-070',
  'SCR-MER-071',
  'SCR-MER-072',
  'SCR-MER-088',
  'SCR-MER-089',
] as const;

export type KitchenDisplayScreenId = (typeof KITCHEN_DISPLAY_SCREEN_IDS)[number];

export const KITCHEN_DISPLAY_ROUTES: Record<KitchenDisplayScreenId, string> = {
  'SCR-MER-063': '/kitchen-display',
  'SCR-MER-064': '/kitchen-ticket-detail',
  'SCR-MER-065': '/kitchen-settings',
  'SCR-MER-066': '/pick-list',
  'SCR-MER-067': '/pick-item',
  'SCR-MER-068': '/propose-substitution',
  'SCR-MER-069': '/pick-complete',
  'SCR-MER-070': '/collection-counter',
  'SCR-MER-071': '/handover',
  'SCR-MER-072': '/age-verification',
  'SCR-MER-088': '/weigh-item',
  'SCR-MER-089': '/weight-exceptions',
};

export const KITCHEN_DISPLAY_PERMISSIONS: Partial<
  Record<KitchenDisplayScreenId, readonly string[]>
> = {
  'SCR-MER-063': [
    'PERM-fulfilment.preparation.start',
    'PERM-fulfilment.item.bump',
    'PERM-fulfilment.delay.flag',
  ],
  'SCR-MER-064': ['PERM-fulfilment.item.bump', 'PERM-fulfilment.ticket.recall'],
  'SCR-MER-065': ['PERM-fulfilment.task.read'],
  'SCR-MER-066': ['PERM-fulfilment.pick.execute'],
  'SCR-MER-067': ['PERM-fulfilment.pick.execute', 'PERM-fulfilment.batch.select'],
  'SCR-MER-068': ['PERM-fulfilment.substitution.propose'],
  'SCR-MER-069': ['PERM-fulfilment.pick.execute'],
  'SCR-MER-070': ['PERM-fulfilment.handover.read'],
  'SCR-MER-071': ['PERM-fulfilment.handover.complete', 'PERM-fulfilment.handover.refuse'],
  'SCR-MER-072': ['PERM-fulfilment.agecheck.record'],
  'SCR-MER-088': ['PERM-fulfilment.pick.execute'],
  'SCR-MER-089': ['PERM-fulfilment.pick.execute', 'PERM-fulfilment.gate.override'],
};

export const KITCHEN_DISPLAY_ENDPOINTS: Partial<Record<KitchenDisplayScreenId, readonly string[]>> =
  {
    'SCR-MER-063': [
      'GET /merchant/v1/orders/board',
      'POST /merchant/v1/orders/{id}/preparing',
      'POST /merchant/v1/orders/{id}/delay',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/bump',
      'POST /merchant/v1/orders/{id}/ticket/recall',
    ],
    'SCR-MER-064': [
      'GET /merchant/v1/fulfilment/tasks/{orderId}',
      'GET /merchant/v1/orders/{id}',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/bump',
      'POST /merchant/v1/orders/{id}/ticket/recall',
      'POST /merchant/v1/orders/{id}/delay',
    ],
    'SCR-MER-065': [
      'GET /merchant/v1/fulfilment/display-settings',
      'PATCH /merchant/v1/fulfilment/display-settings',
      'GET /merchant/v1/fulfilment/capacity',
    ],
    'SCR-MER-066': ['GET /merchant/v1/orders/{id}/pick-list'],
    'SCR-MER-067': [
      'GET /merchant/v1/orders/{id}/pick-list',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/pick',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/unavailable',
    ],
    'SCR-MER-068': [
      'GET /merchant/v1/orders/{id}/substitutions',
      'POST /merchant/v1/orders/{id}/substitutions',
    ],
    'SCR-MER-069': [
      'GET /merchant/v1/orders/{id}/pick-list',
      'GET /merchant/v1/orders/{id}/substitutions',
      'POST /merchant/v1/orders/{id}/pick-list/complete',
    ],
    'SCR-MER-070': ['GET /merchant/v1/orders/board'],
    'SCR-MER-071': [
      'GET /merchant/v1/orders/{id}',
      'POST /merchant/v1/orders/{id}/verify-collection',
      'POST /merchant/v1/orders/{id}/handover',
      'POST /merchant/v1/orders/{id}/handover/refuse',
    ],
    'SCR-MER-072': [
      'GET /merchant/v1/orders/{id}/age-check',
      'POST /merchant/v1/orders/{id}/age-check',
    ],
    'SCR-MER-088': [
      'GET /merchant/v1/orders/{id}/pick-list',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/weight',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/unavailable',
    ],
    'SCR-MER-089': [
      'GET /merchant/v1/orders/{id}/pick-list',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/weight',
      'POST /merchant/v1/orders/{id}/pick-list/items/{itemId}/unavailable',
      'POST /merchant/v1/orders/{id}/fulfilment-gate/override',
      'POST /merchant/v1/orders/{id}/ready',
    ],
  };

export const PICK_ITEM_ID_STORAGE_KEY = 'beatq.merchant.pickItemId';
export const HANDOVER_MATCH_STORAGE_KEY = 'beatq.merchant.handoverMatched';

export const HANDOVER_REFUSE_REASONS = [
  'CUSTOMER_ABSENT',
  'ID_FAILED',
  'ORDER_MISMATCH',
  'OTHER',
] as const;

export const AGE_CHECK_OUTCOMES = ['PASSED', 'FAILED', 'CHALLENGED'] as const;
